import Controller from '@ember/controller';

export default class EventIndexController extends Controller {
  /**
   * Class groups sorted alphabetically by name, with course data enriched
   */
  get sortedClassGroups() {
    const classGroups = this.model?.classGroups || [];
    const eventData = this.model?.eventDataObj;

    return [...classGroups]
      .sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      })
      .map(classGroup => ({
        ...classGroup,
        courseData: this.getCourseDataForClassGroup(classGroup, eventData)
      }));
  }

  /**
   * All unique intermediate timing points across all courses
   */
  get allTimingPoints() {
    const eventData = this.model?.eventDataObj;
    if (!eventData?.courses) {
      return [];
    }

    // Collect all unique timing points from public course elements
    const timingPointMap = new Map();

    for (const course of eventData.courses.values()) {
      if (!course.courseElements) continue;

      course.courseElements.forEach(el => {
        // Only include timing points from public course elements
        if (el.isPublic && el.intermediateTimingPointUuid && el.intermediateTimingPointName) {
          timingPointMap.set(el.intermediateTimingPointUuid, {
            uuid: el.intermediateTimingPointUuid,
            name: el.intermediateTimingPointName,
            description: el.intermediateTimingPointDescription || null
          });
        }
      });
    }

    // Return sorted by name
    return Array.from(timingPointMap.values())
      .sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
  }

  /**
   * Get course data (public elements and timing points) for a class group
   */
  getCourseDataForClassGroup(classGroup, eventData) {
    if (!eventData || !classGroup.courseUuid) {
      return { publicElements: [], timingPoints: [] };
    }

    const course = eventData.courses?.get(classGroup.courseUuid);
    if (!course || !course.courseElements) {
      return { publicElements: [], timingPoints: [] };
    }

    // Get public course elements that have timing points, sorted by order
    // (Only show elements that are public AND have actual split times to display)
    const publicElements = course.courseElements
      .filter(el => el.isPublic && el.intermediateTimingPointUuid)
      .sort((a, b) => (a.order || 0) - (b.order || 0));

    // Get unique timing points used in public elements
    const timingPointMap = new Map();
    publicElements.forEach(el => {
      if (el.intermediateTimingPointUuid && el.intermediateTimingPointName) {
        timingPointMap.set(el.intermediateTimingPointUuid, {
          uuid: el.intermediateTimingPointUuid,
          name: el.intermediateTimingPointName
        });
      }
    });
    const timingPoints = Array.from(timingPointMap.values());

    return { publicElements, timingPoints, course };
  }
}
